<template>
    <div class="py-2 container-fluid mt-2">
        <div class="row">
            <div class="col-6">
                <div class="d-flex justify-content-start">
                    <div v-if="showMenuLgScreen()" style="margin-right: 10px;">
                        <a id="iconNavbarSidenav" href="#" class="p-0 nav-link text-white"
                            @click.prevent="navbarMinimize">
                            <div class="sidenav-toggler-inner">
                                <i class="fa fa-bars fa-2x" aria-hidden="true"></i>
                            </div>
                        </a>
                    </div>
                    <span class="white font-weight-bolder" style="font-size: 20px;">Olá, {{ user }}</span>
                </div>
            </div>
            <div class="col-6">
                <div class="d-flex justify-content-end">
                    <div style="margin-right: 15px;" class="mt-1">
                        <a id="dropdownMenuButton" href="#" class="p-0 nav-link opacity-8 text-white show"
                            data-bs-toggle="dropdown" aria-expanded="false" @click="showMenu = !showMenu"
                            @blur="closeMenu">
                            <div style="position: relative; display: inline-block;">
                                <i style="font-size: 20px; color: white !important;" class="cursor-pointer fa fa-bell white"></i>
                                <badge-total-notifications v-if="contractData" />
                            </div>
                        </a>
                        <notifications-card />
                    </div>
                    <div>
                        <a class="p-0 nav-link">
                            <Avatar :label="user ? user.charAt(0) : 'B'" style="background-color: #ffff; color: #1a2551" shape="circle" />
                            <!-- <i style="font-size: 20px;" class="cursor-pointer fa fa-user fixed-plugin-button-nav opacity-8 text-white"></i> -->
                            <a href="javascript:void(0)" style="margin-left: 5px;" @click="logoutUser()">
                                <span class="sidebar-normal white">Sair</span>
                            </a>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <span class="opacity-7" style="color: #b5b5b5;font-size: 15px;">
                Você está visualizando a unidade <span class="white font-weight-bolder">{{ contractData ?
                    contractData.nome + ' - ' + contractData.contrato_unidade : null }}</span>
            </span>
        </div>
    </div>
</template>

<script setup>
import { computed, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from 'vue-router';
import NotificationsCard from "./components/NotificationsCard.vue";
import BadgeTotalNotifications from "./components/BadgeTotalNotifications.vue";
import Avatar from 'primevue/avatar';

const router = useRouter()
const store = useStore();
const user = store.getters.getCurrentUser ? store.getters.getCurrentUser.name.split(" ")[0] : null;
const contractData = computed(() => store.getters.getCurrentContract);

const logoutUser = () => {
    store.commit('logout')
    router.push('/login')
};

const showMenuLgScreen = () => {
    if (window.innerWidth > 1200) {
        return false;
    }
    return true;
}

const navbarMinimize = () => store.commit("navbarMinimize");

onBeforeUpdate(() => {
    showMenuLgScreen()
});

</script>

<style>
.texto-responsivo {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    font-size: 16px;
}

.p-avatar {
    width: 1.4rem;
    height: 1.4rem;
    font-size: 0.8rem;
}
</style>